import { INVENTORY_PAGE_DEFAULT_BUFFER_FILTER, INVENTORY_PAGE_SKU_BUFFER_FILTER } from './mixpanel';

export const CustomBuffers = {
  CUSTOM_BUFFERS: 'CUSTOM_BUFFERS',
  DEFAULT_BUFFERS: 'DEFAULT_BUFFERS',
};

export const CustomBuffersLabel = {
  [CustomBuffers.CUSTOM_BUFFERS]: 'SKU Level Buffers',
  [CustomBuffers.DEFAULT_BUFFERS]: 'Sales Channel Default',
};

export const BufferStatusToMixpanelEvent = {
  [CustomBuffers.CUSTOM_BUFFERS]: INVENTORY_PAGE_SKU_BUFFER_FILTER,
  [CustomBuffers.DEFAULT_BUFFERS]: INVENTORY_PAGE_DEFAULT_BUFFER_FILTER,
};
